import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=475e5577&"
var script = {}
import style0 from "./Follow.vue?vue&type=style&index=0&id=475e5577&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports